// removed by extract-text-webpack-plugin
module.exports = {"comparison-header-container":"ComparisonHeader__comparison-header-container","comparisonHeaderContainer":"ComparisonHeader__comparison-header-container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonHeader/ComparisonHeader.css
// module id = 1322
// module chunks = 8